import { ManageTranscriberPageContent } from './components/ManageTranscriberPageContent';
import { TranscriberProvider } from './TranscriberContext';

export const ManageTranscriberPage: React.FC = () => {
  return (
    <TranscriberProvider>
      <ManageTranscriberPageContent />
    </TranscriberProvider>
  );
};
